const Header = () => {
	const block = document.querySelector(".header");
	if (!block) {
		return;
	}

	const handleScroll = () => {
		if (window.scrollY > 0) {
			block.classList.add("is-sticky");
		} else {
			block.classList.remove("is-sticky");
		}
	};

	window.addEventListener("scroll", handleScroll);

	handleScroll();
};

export default Header;
